import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { EnrollSessionService } from '../enrollSession.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RestService } from '../rest.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'cookie',
  templateUrl: './cookie-dialog.component.html',
  styleUrls: ['./cookie-dialog.component.scss']
})
export class CookieComponent implements OnInit {
  mobileView:any;
  /**
    * Constructor
    *
    * @param {FuseConfigService} _fuseConfigService
    * @param {FormBuilder} _formBuilder
    */
  constructor(
    public dialogRef: MatDialogRef<CookieComponent>,
    public _enrollSession: EnrollSessionService,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _toastr: ToastrService,
    public _restService: RestService,
    private cookieService: CookieService) {
  }

  ngOnInit(): void {
    let screenWidth = window.innerWidth
      if (screenWidth < 550) {
        this.mobileView = true;
      }
      else {
        this.mobileView = false;
      }
  }

  closeCookie(isCookieAccept): void {
    // Set cookie acceptance for 1 year (365 days)
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 365);

    this.cookieService.set('isAcceptCookie', isCookieAccept.toString(), expirationDate, '/');
    this.dialogRef.close();
  }
}
